// Vendor libraries
import { EventEmitter, NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, takeWhile } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';
// Utils / constants
import { convertModulesToSaveState } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/utils/custom-pdf-report-builder-utils';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import equal from 'NewAngular/utils/equal/deep-equal';
import { NAMING_CONVENTION_PREFERENCE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/constants';
import { NAMING_CONVENTION_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { REPORT_TYPE_LABELS } from 'CustomPDFReportsApp/ts/constants';
import { DEFAULT_SAVED_ASSET_OPTIONS_CHOICES } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-saved-asset-options/interfaces/constants';
import { CUSTOM_PDF_REPORT_BUILDER_APP_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/constants';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { ReportNamingConvention } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/naming-convention.enum';
import { CustomPDFReportNumRequiredSecurities } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-required-num-securities.enum';
// Directives
import { ReportSecuritySearchModalDirective } from 'CustomPDFReportsApp/ts/directives/report-security-search-modal.directive';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { CustomPDFReportService } from 'CustomPDFReportsApp/ts/services/custom-pdf-report.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
// Actions
import { addComparisonSecurity, removeComparisonSecurity, setComparisonSecurities, setPrimarySecurity, setSecondarySecurity, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/report-securities/report-securities.actions';
import { addSelectedReportWizardStep, removeSelectedReportWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selected-report/selected-report.actions';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { setNamingConvention } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/naming-convention/naming-convention.actions';
// Selectors
import { getComparisonSecurities, getCurrentWizardStep, getCurrentWizardStepIndex, getIsLastStep, getNamingConvention, getPrimarySecurity, getNumRequiredSecurities, getSavedAssetSecuritiesSelections, getSecondarySecurity, getSelectedReport, getWizardStepEventName, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { hasEfficientFrontierModules } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/state/custom-pdf-report-builder.selector';
import { setExportOption } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/export-option/export-option.actions';
import * as i0 from "@angular/core";
import * as i1 from "CustomPDFReportsApp/ts/services/custom-pdf-report.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "AccountsApp/ts/services/accounts.service";
import * as i4 from "@ngrx/store";
import * as i5 from "@angular/common";
import * as i6 from "../../../custom-pdf-report-saved-asset-options/custom-pdf-report-saved-asset-options.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i8 from "@angular/forms";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i12 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i13 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/report-security-search-modal/primary-report-security-search-input.component";
import * as i14 from "CustomPDFReportsApp/ts/features/custom-pdf-report-modal/components/report-security-search-modal/report-security-search-input.component";
import * as i15 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
const _c0 = () => ({ button: "btn btn-secondary btn-block" });
const _c1 = () => [];
function ReportSecuritySearchModalComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "div", 25)(2, "div", 26);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 27);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5, "Not all securities will appear in report");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "p");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "p");
    i0.ɵɵtext(9, "To ensure all securities appear, you can update the securities below. Alternatively, modify ");
    i0.ɵɵelementStart(10, "a", 28);
    i0.ɵɵtext(11, "Efficient Frontier Settings");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(12, " directly. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "button", 29);
    i0.ɵɵlistener("click", function ReportSecuritySearchModalComponent_div_5_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.enableEditSecurities()); });
    i0.ɵɵtext(14, "Update securities below");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1("The securities with error(s) below do not support settings in the Efficient Frontier module, so they will not be able to appear. Click ", ctx_r2.buttonText, " below to continue with securities as-is.");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("href", ctx_r2.efficientFrontierModuleUrl, i0.ɵɵsanitizeUrl);
} }
function ReportSecuritySearchModalComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "div", 25)(2, "div", 26);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 27);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5, "Not all securities are supported");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "p");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "p");
    i0.ɵɵtext(9, "To ensure all securities are supported, you can update the securities below.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 29);
    i0.ɵɵlistener("click", function ReportSecuritySearchModalComponent_div_6_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r4); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.enableEditSecurities()); });
    i0.ɵɵtext(11, "Update securities below");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1("The securities with error(s) below are not supported in the report. Click ", ctx_r2.buttonText, " below to continue with securities as-is.");
} }
function ReportSecuritySearchModalComponent_p_7_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelement(1, "br")(2, "span", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", ctx_r2.message.message_text);
} }
function ReportSecuritySearchModalComponent_p_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p")(1, "span", 30);
    i0.ɵɵtext(2, "Securities");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "br")(4, "span", 31);
    i0.ɵɵtemplate(5, ReportSecuritySearchModalComponent_p_7_span_5_Template, 3, 1, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    let tmp_2_0;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("textContent", ctx_r2.instructionTextByReportType[(tmp_2_0 = ctx_r2.selectedReportType) !== null && tmp_2_0 !== undefined ? tmp_2_0 : ctx_r2.REPORT_TYPES.AGGREGATE_SECURITY_OVERVIEW]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.message.message_text);
} }
function ReportSecuritySearchModalComponent_td_14_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 33)(1, "div", 34)(2, "div", 35);
    i0.ɵɵtext(3, "Will Show As");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ycn-single-select-dropdown", 36);
    i0.ɵɵlistener("changeHandler", function ReportSecuritySearchModalComponent_td_14_Template_ycn_single_select_dropdown_changeHandler_4_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectNamingConvention($event)); });
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(3, _c0))("config", ctx_r2.namingConventionDropdownConfig)("selectedValue", ctx_r2.namingConvention);
} }
function ReportSecuritySearchModalComponent_tbody_15_ycn_report_security_search_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-report-security-search-input", 41, 2);
    i0.ɵɵlistener("customLabelEmitter", function ReportSecuritySearchModalComponent_tbody_15_ycn_report_security_search_input_3_Template_ycn_report_security_search_input_customLabelEmitter_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.updateCustomLabelHandler(1, $event)); })("selectSecurityHandler", function ReportSecuritySearchModalComponent_tbody_15_ycn_report_security_search_input_3_Template_ycn_report_security_search_input_selectSecurityHandler_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.selectSecondarySecurityHandler($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    let tmp_7_0;
    let tmp_8_0;
    let tmp_9_0;
    let tmp_13_0;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("rowCount", 2)("autocompleterTestID", "secondary-security-autocomplete")("errorMessage", (tmp_7_0 = ctx_r2.secondarySecurity.errorMessage) !== null && tmp_7_0 !== undefined ? tmp_7_0 : "")("disableEditBtn", (tmp_8_0 = ctx_r2.secondarySecurity.disableEditBtn) !== null && tmp_8_0 !== undefined ? tmp_8_0 : false)("disableAutocompleterInput", (tmp_9_0 = ctx_r2.secondarySecurity.disableEditBtn) !== null && tmp_9_0 !== undefined ? tmp_9_0 : false)("reportLabelPreview", ctx_r2.securityLabelPreviews[1] || "")("namingConvention", ctx_r2.namingConvention)("customLabel", ctx_r2.secondarySecurity.customLabel)("displayIdentifier", (tmp_13_0 = ctx_r2.secondarySecurity.securityId) !== null && tmp_13_0 !== undefined ? tmp_13_0 : "")("showControls", false);
} }
function ReportSecuritySearchModalComponent_tbody_15_ycn_report_security_search_input_4_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-report-security-search-input", 42);
    i0.ɵɵlistener("customLabelEmitter", function ReportSecuritySearchModalComponent_tbody_15_ycn_report_security_search_input_4_Template_ycn_report_security_search_input_customLabelEmitter_0_listener($event) { const index_r9 = i0.ɵɵrestoreView(_r8).index; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.updateCustomLabelHandler(index_r9 + 2, $event)); })("selectSecurityHandler", function ReportSecuritySearchModalComponent_tbody_15_ycn_report_security_search_input_4_Template_ycn_report_security_search_input_selectSecurityHandler_0_listener($event) { const index_r9 = i0.ɵɵrestoreView(_r8).index; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.upsertSecurity($event, index_r9)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    let tmp_8_0;
    let tmp_9_0;
    let tmp_10_0;
    let tmp_13_0;
    let tmp_14_0;
    const index_r9 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("rowCount", index_r9 + 2)("autocompleterTestID", "comparison-security-autocomplete-" + index_r9)("errorMessage", (tmp_8_0 = ctx_r2.comparisonSecurities[index_r9] == null ? null : ctx_r2.comparisonSecurities[index_r9].errorMessage) !== null && tmp_8_0 !== undefined ? tmp_8_0 : "")("disableEditBtn", (tmp_9_0 = ctx_r2.comparisonSecurities[index_r9] == null ? null : ctx_r2.comparisonSecurities[index_r9].disableEditBtn) !== null && tmp_9_0 !== undefined ? tmp_9_0 : false)("disableAutocompleterInput", (tmp_10_0 = ctx_r2.comparisonSecurities[index_r9] == null ? null : ctx_r2.comparisonSecurities[index_r9].disableEditBtn) !== null && tmp_10_0 !== undefined ? tmp_10_0 : false)("reportLabelPreview", ctx_r2.securityLabelPreviews[index_r9 + 2] != null ? ctx_r2.securityLabelPreviews[index_r9 + 2] : "")("namingConvention", ctx_r2.namingConvention)("customLabel", (tmp_13_0 = ctx_r2.comparisonSecurities[index_r9] == null ? null : ctx_r2.comparisonSecurities[index_r9].customLabel) !== null && tmp_13_0 !== undefined ? tmp_13_0 : "")("displayIdentifier", (tmp_14_0 = ctx_r2.comparisonSecurities[index_r9] == null ? null : ctx_r2.comparisonSecurities[index_r9].securityId) !== null && tmp_14_0 !== undefined ? tmp_14_0 : "")("sortable", true)("removeSecurityHandler", ctx_r2.removeSecurityHandlerFac(index_r9))("showControls", index_r9 > 1);
} }
function ReportSecuritySearchModalComponent_tbody_15_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tbody", 37)(1, "ycn-primary-report-security-search-input", 38, 1);
    i0.ɵɵlistener("customLabelEmitter", function ReportSecuritySearchModalComponent_tbody_15_Template_ycn_primary_report_security_search_input_customLabelEmitter_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateCustomLabelHandler(0, $event)); })("selectSecurityHandler", function ReportSecuritySearchModalComponent_tbody_15_Template_ycn_primary_report_security_search_input_selectSecurityHandler_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectPrimarySecurityHandler($event)); })("selectSecurityListHandler", function ReportSecuritySearchModalComponent_tbody_15_Template_ycn_primary_report_security_search_input_selectSecurityListHandler_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectPrimarySecurityListHandler($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ReportSecuritySearchModalComponent_tbody_15_ycn_report_security_search_input_3_Template, 2, 10, "ycn-report-security-search-input", 39)(4, ReportSecuritySearchModalComponent_tbody_15_ycn_report_security_search_input_4_Template, 1, 12, "ycn-report-security-search-input", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    let tmp_5_0;
    let tmp_7_0;
    let tmp_8_0;
    let tmp_9_0;
    let tmp_13_0;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r2.sortableContainerId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("rowCount", 1)("allowSecurityLists", ctx_r2.allowSecurityLists && !((tmp_5_0 = ctx_r2.primarySecurity.disableEditBtn) !== null && tmp_5_0 !== undefined ? tmp_5_0 : false))("autocompleterTestID", "primary-security-autocomplete")("errorMessage", (tmp_7_0 = ctx_r2.primarySecurity.errorMessage) !== null && tmp_7_0 !== undefined ? tmp_7_0 : "")("disableEditBtn", (tmp_8_0 = ctx_r2.primarySecurity.disableEditBtn) !== null && tmp_8_0 !== undefined ? tmp_8_0 : false)("disableAutocompleterInput", (tmp_9_0 = ctx_r2.primarySecurity.disableEditBtn) !== null && tmp_9_0 !== undefined ? tmp_9_0 : false)("reportLabelPreview", ctx_r2.securityLabelPreviews[0] || "")("namingConvention", ctx_r2.namingConvention)("customLabel", ctx_r2.primarySecurity.customLabel)("displayIdentifier", (tmp_13_0 = ctx_r2.primarySecurity.securityId) !== null && tmp_13_0 !== undefined ? tmp_13_0 : "")("securityListGroup", ctx_r2.primarySecurity.securityListGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.numRequiredSecurities === 2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(14, _c1).constructor(ctx_r2.additionalSecurityInputCount));
} }
function ReportSecuritySearchModalComponent_a_16_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 43);
    i0.ɵɵlistener("click", function ReportSecuritySearchModalComponent_a_16_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.createAdditionalSecurityInput()); });
    i0.ɵɵtext(1, " Add Security ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r2.comparisonSecurities.length < ctx_r2.minSecurities ? "text-gray-50" : "text-blue");
} }
function ReportSecuritySearchModalComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 44)(1, "label", 45)(2, "input", 46);
    i0.ɵɵtwoWayListener("ngModelChange", function ReportSecuritySearchModalComponent_div_17_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r2 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r2.showAdvancedOptions, $event) || (ctx_r2.showAdvancedOptions = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function ReportSecuritySearchModalComponent_div_17_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateAdvancedOptionsPreference($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 47);
    i0.ɵɵelementStart(4, "span", 48);
    i0.ɵɵtext(5, "Show Advanced Options");
    i0.ɵɵelementEnd()();
    i0.ɵɵtext(6, " \u00A0 ");
    i0.ɵɵelementStart(7, "span", 49);
    i0.ɵɵlistener("click", function ReportSecuritySearchModalComponent_div_17_Template_span_click_7_listener() { i0.ɵɵrestoreView(_r11); i0.ɵɵnextContext(); const helpModal_r12 = i0.ɵɵreference(29); return i0.ɵɵresetView(helpModal_r12.openModal("advanced_report_generation_options")); });
    i0.ɵɵtext(8, "(?)");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.showAdvancedOptions);
} }
function ReportSecuritySearchModalComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "ycn-custom-pdf-report-saved-asset-options", 50);
    i0.ɵɵlistener("updateFieldChoice", function ReportSecuritySearchModalComponent_div_18_Template_ycn_custom_pdf_report_saved_asset_options_updateFieldChoice_1_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updateSavedAssetSecuritiesChoice($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("currentValues", ctx_r2.selectedReportAdvancedOptions || ctx_r2.DEFAULT_SAVED_ASSET_OPTIONS_CHOICES)("savedAssetSecuritiesFields", ctx_r2.savedAssetSecuritiesFields)("dropdownsFieldChoices", ctx_r2.currentWizardStep == null ? null : ctx_r2.currentWizardStep.extraFields);
} }
function ReportSecuritySearchModalComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵelement(1, "div", 52);
    i0.ɵɵelementEnd();
} }
function ReportSecuritySearchModalComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 53);
    i0.ɵɵlistener("click", function ReportSecuritySearchModalComponent_div_24_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.back()); });
    i0.ɵɵtext(1, "Back ");
    i0.ɵɵelementEnd();
} }
function ReportSecuritySearchModalComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵelement(1, "div", 55);
    i0.ɵɵelementEnd();
} }
/**
 * Report Security Search Modal Component
 *
 * Handles searching for and selecting securities for all custom PDF report types.
 *
 * Output Properties:
 *  broadcastWizardStepEvent: emits when the wizard should move to the previous step or next step
 */
export class ReportSecuritySearchModalComponent extends ReportSecuritySearchModalDirective {
    constructor(customPDFReportService, featureService, accountsService, store, ngZone) {
        super(accountsService, ngZone, store);
        this.customPDFReportService = customPDFReportService;
        this.featureService = featureService;
        this.accountsService = accountsService;
        this.store = store;
        this.ngZone = ngZone;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.isLastStep = null;
        this.selectedReport = {};
        this.headerText = 'Generate Report';
        this.savedAssetSecuritiesFieldSortOrder = {
            fund_chart_securities_choice: 0,
            scatter_plot_securities_choice: 1,
            comp_table_securities_choice: 2,
            timeseries_table_securities_choice: 3,
        };
        this.allowSecurityLists = true;
        this.selectedReportAdvancedOptions = null;
        this.DEFAULT_SAVED_ASSET_OPTIONS_CHOICES = DEFAULT_SAVED_ASSET_OPTIONS_CHOICES;
        this.hasEfficientFrontierModules = false;
        this.securitiesValidationFailed = false;
        this.USER = window.USER;
        this.mapBuilderStateToComponent = (state) => {
            this.hasEfficientFrontierModules = hasEfficientFrontierModules(state);
            if (state) {
                this.modules = state.report.modules;
            }
        };
        this.mapStateToComponent = (state) => {
            this.namingConvention = getNamingConvention(state);
            const prevPrimarySecurity = this.primarySecurity;
            this.primarySecurity = getPrimarySecurity(state);
            this.secondarySecurity = getSecondarySecurity(state);
            this.comparisonSecurities = getComparisonSecurities(state);
            this.selectedReport = getSelectedReport(state);
            this.selectedReportType = this.selectedReport.report_type;
            this.numRequiredSecurities = getNumRequiredSecurities(state);
            this.isMultiSecurityReport = this.numRequiredSecurities === CustomPDFReportNumRequiredSecurities.THREE_PLUS;
            this.selectedReportAdvancedOptions = {
                fund_chart_securities_choice: state.fundChartSecuritiesChoice,
                scatter_plot_securities_choice: state.scatterPlotSecuritiesChoice,
                comp_table_securities_choice: state.compTableSecuritiesChoice,
                timeseries_table_securities_choice: state.timeseriesTableSecuritiesChoice,
            };
            this.headerText = this.selectedReportType
                ? `Generate ${REPORT_TYPE_LABELS[this.selectedReportType]} Report`
                : 'Generate Report';
            this.savedAssetSecuritiesSelections = getSavedAssetSecuritiesSelections(state);
            this.currentWizardStepIndex = getCurrentWizardStepIndex(state);
            this.currentWizardStep = getCurrentWizardStep(state);
            this.savedAssetSecuritiesFields = Object.keys(this.currentWizardStep?.extraFields ?? {}).sort((a, b) => this.savedAssetSecuritiesFieldSortOrder[a] - this.savedAssetSecuritiesFieldSortOrder[b]);
            this.hidePrimarySecuritySearch = this.selectedReport.wizard_steps?.some((step) => step.eventName === CustomPDFReportModalEventName.SHOW_REPORT_MENU_MODAL);
            if (!this.isOpen &&
                this.currentWizardStepIndex === 0 &&
                getWizardStepEventName(state) === CustomPDFReportModalEventName.SHOW_SECURITY_SEARCH_MODAL) {
                this.openModal();
            }
            this.isLastStep = getIsLastStep(state);
            this.buttonText = this.isLastStep ? 'GENERATE' : 'NEXT';
            this.interpretSecurityLabelPreview();
            this.validateSecurities();
            // If a security list is selected then validate it
            if (this.primarySecurity.securityListGroup &&
                !equal(prevPrimarySecurity, this.primarySecurity) &&
                this.selectedReport.report_id) {
                this.loading = true;
                this.customPDFReportService
                    .validateReportSecurityList(this.selectedReport.report_id, this.primarySecurity.securityId, this.primarySecurity.securityListGroup)
                    .subscribe({
                    next: (response) => {
                        this.message = response;
                        this.loading = false;
                    },
                    error: () => {
                        this.loading = false;
                    },
                });
            }
            else if (!this.primarySecurity.securityListGroup) {
                this.message = {
                    message_text: '',
                    message_type: null,
                };
            }
            this.securitiesSubmitError = [this.primarySecurity, this.secondarySecurity, ...this.comparisonSecurities].some((item) => item.errorMessage);
        };
        this.setSecondarySecurity = (secondarySecurity) => {
            this.store.dispatch(setSecondarySecurity({ ...secondarySecurity }));
        };
        this.setComparisonSecurities = (comparisonSecurities) => {
            this.store.dispatch(setComparisonSecurities({ comparisonSecurities }));
        };
    }
    ngOnInit() {
        super.ngOnInit();
        this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(this.mapStateToComponent);
        this.store
            .select((state) => (state.reducers ? state.reducers[CUSTOM_PDF_REPORT_BUILDER_APP_STATE_SLICE_KEY] : null))
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(this.mapBuilderStateToComponent);
        this.accountsService.getUserPreferences().subscribe({
            next: (response) => {
                this.showAdvancedOptions = response.show_advanced_report_generation_options;
            },
            error: () => {
                this.showAdvancedOptions = true;
            },
        });
        if (this.featureService.userHasFeatures([NAMING_CONVENTION_FEATURE])) {
            this.namingConventionFeature = true;
            this.getNamingConventionPreference()
                .pipe(first())
                .subscribe((namingConvention) => {
                this.store.dispatch(setNamingConvention({ namingConvention }));
            });
        }
        else {
            this.store.dispatch(setNamingConvention({ namingConvention: ReportNamingConvention.TRUNCATED }));
        }
    }
    ngAfterViewInit() {
        this.initializeSortable();
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    upsertSecurity(securityObject, comparisonSecurityIDX = -1) {
        const { search_id, name, display_security_id, type } = securityObject;
        const newSecurity = {
            securityId: search_id,
            securityName: name,
            displaySecurityID: display_security_id,
            securityType: type,
            errorMessage: '',
            disableEditBtn: false,
        };
        while (this.comparisonSecurities.length < comparisonSecurityIDX) {
            this.comparisonSecurities = [
                ...this.comparisonSecurities,
                {
                    securityId: null,
                    securityName: null,
                    displaySecurityID: null,
                    securityType: null,
                    errorMessage: '',
                    disableEditBtn: false,
                },
            ];
        }
        if (comparisonSecurityIDX === -1) {
            this.store.dispatch(addComparisonSecurity(newSecurity));
        }
        else {
            const comparisonSecurities = [...this.comparisonSecurities];
            comparisonSecurities[comparisonSecurityIDX] = newSecurity;
            this.store.dispatch(setComparisonSecurities({ comparisonSecurities }));
        }
        this.securitiesValidationFailed = false;
    }
    removeSecurity(index) {
        this.store.dispatch(removeComparisonSecurity({ index }));
    }
    selectPrimarySecurityHandler(securityObject) {
        const { search_id, name, display_security_id, type } = securityObject;
        // If the previously primary security had export option remove the wizard step and reset the value
        if (this.primarySecurity.securityListGroup) {
            this.store.dispatch(removeSelectedReportWizardStep({
                eventName: CustomPDFReportModalEventName.SHOW_EXPORT_OPTIONS_MODAL,
            }));
            this.store.dispatch(setExportOption({ exportOption: null }));
        }
        this.store.dispatch(setPrimarySecurity({
            securityId: search_id,
            securityName: name,
            displaySecurityID: display_security_id,
            securityType: type,
            errorMessage: '',
            disableEditBtn: false,
        }));
        this.securitiesValidationFailed = false;
    }
    selectPrimarySecurityListHandler({ securityList, securityGroup, }) {
        const addExportOptionStep = Boolean(this.selectedReport.wizard_steps[1].eventName !== CustomPDFReportModalEventName.SHOW_EXPORT_OPTIONS_MODAL);
        if (addExportOptionStep) {
            const securitySearchIndex = this.selectedReport.wizard_steps.findIndex((step) => step.eventName === CustomPDFReportModalEventName.SHOW_SECURITY_SEARCH_MODAL);
            this.store.dispatch(addSelectedReportWizardStep({
                newStep: { eventName: CustomPDFReportModalEventName.SHOW_EXPORT_OPTIONS_MODAL },
                index: securitySearchIndex + 1,
            }));
        }
        else {
            this.store.dispatch(setExportOption({ exportOption: null }));
        }
        this.store.dispatch(setPrimarySecurity({
            securityId: 'search_id' in securityList ? securityList.search_id : securityList.key,
            securityName: securityList.name,
            displaySecurityID: null,
            securityType: null,
            securityListGroup: securityGroup,
            errorMessage: '',
            disableEditBtn: false,
        }));
    }
    selectSecondarySecurityHandler(securityObject) {
        const { search_id, name, display_security_id, type } = securityObject;
        this.store.dispatch(setSecondarySecurity({
            securityId: search_id,
            securityName: name,
            displaySecurityID: display_security_id,
            securityType: type,
            errorMessage: '',
            disableEditBtn: false,
        }));
    }
    updateCustomLabelHandler(securityIDX, customLabel) {
        switch (securityIDX) {
            case 0:
                this.store.dispatch(setPrimarySecurity({
                    ...this.primarySecurity,
                    customLabel,
                }));
                break;
            case 1:
                this.store.dispatch(setSecondarySecurity({
                    ...this.secondarySecurity,
                    customLabel,
                }));
                break;
            default:
                const targetSecurity = this.comparisonSecurities[securityIDX - 2];
                const comparisonSecurities = [...this.comparisonSecurities];
                comparisonSecurities[securityIDX - 2] = {
                    ...targetSecurity,
                    customLabel,
                };
                this.setComparisonSecurities(comparisonSecurities);
        }
        this.interpretSecurityLabelPreview();
        this.validateSecurities();
    }
    selectNamingConvention(namingConvention) {
        this.store.dispatch(setNamingConvention({ namingConvention }));
        this.interpretSecurityLabelPreview();
        this.validateSecurities();
    }
    exitModalHandler() {
        this.closeModal();
        this.store.dispatch(resetAllCustomPdfReportItems());
    }
    cancelEditing() {
        if (this.primarySecurity.securityId && this.primarySecurityInput) {
            this.primarySecurityInput.cancel();
        }
        if (this.secondarySecurity.securityId && this.secondarySecurityInput) {
            this.secondarySecurityInput.cancel();
        }
    }
    back() {
        this.closeModal();
        if (this.currentWizardStepIndex) {
            this.cancelEditing();
            this.store.dispatch(decrementCurrentWizardStep());
            this.broadcastWizardStepEvent.emit();
        }
        else {
            this.primarySecurityInput.reset();
            this.secondarySecurityInput.reset();
            this.store.dispatch(resetAllCustomPdfReportItems());
        }
    }
    forward() {
        this.loading = true;
        this.validateReportSecurities().subscribe({
            next: () => {
                this.loading = false;
                this.securitiesValidationFailed = false;
                this.closeModal();
                this.setNamingConventionPreference();
                this.cancelEditing();
                this.store.dispatch(incrementCurrentWizardStep());
                this.broadcastWizardStepEvent.emit();
            },
            error: (error) => {
                this.securitiesValidationFailed = true;
                this.loading = false;
                this.securitiesSubmitError = true;
                const securitiesErrors = error.error.error_message;
                this.efficientFrontierModuleUrl = error.error.portfolio_optimizer_url;
                this.setErrorsInReportSecurities(securitiesErrors);
            },
        });
    }
    validateReportSecurities() {
        if (this.securitiesValidationFailed) {
            return of({});
        }
        const security_ids = [
            this.primarySecurity.securityId,
            this.secondarySecurity.securityId,
            ...this.comparisonSecurities.map((security) => security.securityId),
        ].flatMap((security) => (security ? [security] : []));
        const securitylist_group = this.primarySecurity.securityListGroup;
        return this.customPDFReportService.validateReportSecurities(this.selectedReport.report_id, this.modules ? convertModulesToSaveState(this.modules) : null, security_ids, securitylist_group);
    }
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    setNamingConventionPreference() {
        localStorage.setItem(NAMING_CONVENTION_PREFERENCE_KEY, this.namingConvention);
    }
}
ReportSecuritySearchModalComponent.ɵfac = function ReportSecuritySearchModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ReportSecuritySearchModalComponent)(i0.ɵɵdirectiveInject(i1.CustomPDFReportService), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i3.AccountsService), i0.ɵɵdirectiveInject(i4.Store), i0.ɵɵdirectiveInject(i0.NgZone)); };
ReportSecuritySearchModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ReportSecuritySearchModalComponent, selectors: [["ycn-report-security-search-modal"]], outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 30, vars: 16, consts: [["helpModal", ""], ["primarySecurityInput", ""], ["secondarySecurityInput", ""], [3, "closeModalHandler", "open", "requiresAction"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section", "mb-3"], ["class", "form-message form-message-signal mb-1", 4, "ngIf"], [4, "ngIf"], [1, "table"], [1, "pl-0", "col-7"], [1, "form-label", "form-label-thin"], ["class", "pr-0 col-5", 4, "ngIf"], [3, "id", 4, "ngIf"], ["class", "d-inline-block mt-1 ml-20 ng-hide text-gray-50", "href", "javascript:void(0);", "data-test-id", "add-comparison-security", 3, "ngClass", "click", 4, "ngIf"], ["class", "modal-section mb-row", 4, "ngIf"], ["class", "modal-section mb-3", 4, "ngIf"], ["class", "modal-section", 4, "ngIf"], [1, "modal-footer"], [1, "modal-footer-actions"], [1, "btn", "btn-text", 3, "click"], ["class", "btn btn-secondary", 3, "click", 4, "ngIf"], ["data-test-id", "submit-pdf-report-securities", "ycnDisabled", "", 1, "btn", "btn-primary", 3, "click", "disabled"], ["class", "ml-1", 4, "ngIf"], [1, "form-message", "form-message-signal", "mb-1"], [1, "form-message-wrap"], [1, "form-message-title", "mb-2"], ["ycnIcon", "", "name", "icon-warning-triangle"], [1, "text-blue", 3, "href"], [1, "btn", "btn-outline", "btn-ghost", 3, "click"], [1, "text-bold"], [1, "text-gray-30", 3, "textContent"], [1, "text-red", 3, "textContent"], [1, "pr-0", "col-5"], [1, "form-inline"], [1, "form-label", "form-label-thin", "text-nowrap"], [1, "dropdown", "flex-auto", "text-nowrap", 3, "changeHandler", "customCssClasses", "config", "selectedValue"], [3, "id"], [3, "customLabelEmitter", "selectSecurityHandler", "selectSecurityListHandler", "rowCount", "allowSecurityLists", "autocompleterTestID", "errorMessage", "disableEditBtn", "disableAutocompleterInput", "reportLabelPreview", "namingConvention", "customLabel", "displayIdentifier", "securityListGroup"], [3, "rowCount", "autocompleterTestID", "errorMessage", "disableEditBtn", "disableAutocompleterInput", "reportLabelPreview", "namingConvention", "customLabel", "displayIdentifier", "showControls", "customLabelEmitter", "selectSecurityHandler", 4, "ngIf"], [3, "rowCount", "autocompleterTestID", "errorMessage", "disableEditBtn", "disableAutocompleterInput", "reportLabelPreview", "namingConvention", "customLabel", "displayIdentifier", "sortable", "removeSecurityHandler", "showControls", "customLabelEmitter", "selectSecurityHandler", 4, "ngFor", "ngForOf"], [3, "customLabelEmitter", "selectSecurityHandler", "rowCount", "autocompleterTestID", "errorMessage", "disableEditBtn", "disableAutocompleterInput", "reportLabelPreview", "namingConvention", "customLabel", "displayIdentifier", "showControls"], [3, "customLabelEmitter", "selectSecurityHandler", "rowCount", "autocompleterTestID", "errorMessage", "disableEditBtn", "disableAutocompleterInput", "reportLabelPreview", "namingConvention", "customLabel", "displayIdentifier", "sortable", "removeSecurityHandler", "showControls"], ["href", "javascript:void(0);", "data-test-id", "add-comparison-security", 1, "d-inline-block", "mt-1", "ml-20", "ng-hide", "text-gray-50", 3, "click", "ngClass"], [1, "modal-section", "mb-row"], [1, "custom-control", "custom-checkbox", "mr-0"], ["type", "checkbox", 1, "custom-control-input", 3, "ngModelChange", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"], [1, "help-toggler", 3, "click"], [3, "updateFieldChoice", "currentValues", "savedAssetSecuritiesFields", "dropdownsFieldChoices"], [1, "modal-section"], [1, "divider-horizontal"], [1, "btn", "btn-secondary", 3, "click"], [1, "ml-1"], [1, "loader-spinner-context", "loader-xs"]], template: function ReportSecuritySearchModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 3);
        i0.ɵɵlistener("closeModalHandler", function ReportSecuritySearchModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 4);
        i0.ɵɵlistener("closeModalHandler", function ReportSecuritySearchModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 5)(3, "div")(4, "div", 6);
        i0.ɵɵtemplate(5, ReportSecuritySearchModalComponent_div_5_Template, 15, 2, "div", 7)(6, ReportSecuritySearchModalComponent_div_6_Template, 12, 1, "div", 7)(7, ReportSecuritySearchModalComponent_p_7_Template, 6, 2, "p", 8);
        i0.ɵɵelementStart(8, "table", 9)(9, "thead")(10, "tr")(11, "td", 10)(12, "div", 11);
        i0.ɵɵtext(13, "Security");
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(14, ReportSecuritySearchModalComponent_td_14_Template, 5, 4, "td", 12);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(15, ReportSecuritySearchModalComponent_tbody_15_Template, 5, 15, "tbody", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, ReportSecuritySearchModalComponent_a_16_Template, 2, 1, "a", 14);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(17, ReportSecuritySearchModalComponent_div_17_Template, 9, 1, "div", 15)(18, ReportSecuritySearchModalComponent_div_18_Template, 2, 3, "div", 16)(19, ReportSecuritySearchModalComponent_div_19_Template, 2, 0, "div", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 18)(21, "div", 19)(22, "div", 20);
        i0.ɵɵlistener("click", function ReportSecuritySearchModalComponent_Template_div_click_22_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.exitModalHandler()); });
        i0.ɵɵtext(23, "Cancel ");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(24, ReportSecuritySearchModalComponent_div_24_Template, 2, 0, "div", 21);
        i0.ɵɵelementStart(25, "div", 22);
        i0.ɵɵlistener("click", function ReportSecuritySearchModalComponent_Template_div_click_25_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.forward()); });
        i0.ɵɵtext(26);
        i0.ɵɵtemplate(27, ReportSecuritySearchModalComponent_div_27_Template, 2, 0, "div", 23);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelement(28, "ycn-help-modal", null, 0);
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen)("requiresAction", true);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.headerText);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.securitiesSubmitError && ctx.hasEfficientFrontierModules);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.securitiesSubmitError && !ctx.hasEfficientFrontierModules);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.securitiesSubmitError);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", ctx.namingConventionFeature);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showSortable);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.isMultiSecurityReport && ctx.comparisonSecurities.length < ctx.maxSecurities);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.savedAssetSecuritiesFields.length);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.savedAssetSecuritiesFields.length && ctx.showAdvancedOptions);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.savedAssetSecuritiesFields.length);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.currentWizardStepIndex != 0);
        i0.ɵɵadvance();
        i0.ɵɵproperty("disabled", ctx.forwardDisabled || ctx.message.message_type === "error" || ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate1(" ", ctx.buttonText, " ");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.loading);
    } }, dependencies: [i5.NgClass, i5.NgForOf, i5.NgIf, i6.CustomPdfReportSavedAssetOptions, i7.DisabledDirective, i8.CheckboxControlValueAccessor, i8.NgControlStatus, i8.NgModel, i9.HelpModalComponent, i10.IconDirective, i11.ModalBaseComponent, i12.SimpleModalHeaderComponent, i13.PrimaryReportSecuritySearchInputComponent, i14.ReportSecuritySearchInputComponent, i15.SingleSelectDropdownComponent], encapsulation: 2 });
